import m from "mithril";
import Requester from "../../../shared/request";
import Gateway from "../../../shared/app_settings";
import i18n from "../../../shared/i18n/i18n";
import Toasts from "../../../shared/toasts";
import ModalManager from "../../../shared/modal";
import FormUtilities from "../../../shared/utilities/form_utilities";
import UniqueName from "../../../shared/uniqueName";
import RouterService from "../../../shared/services/router.service";
import TextEditor from "../../../shared/components/component_text_editor";


let saving = false;
let unit = {
    name: "",
    description: "",
    instructions: ""
};
let modalId;

function saveUnit() {
    if (FormUtilities.validateFields(".modal input")) {
        saving = true;
        Requester.post(Gateway.admin + "units/form", unit)
            .then(function (result) {
                ModalManager.close(modalId);
                RouterService.navigateToUnit(result);
            }).catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        }).finally(function () {
            saving = false;
        });
    }
}

const Modal_Unit_Form_New = {
    oninit: function() {
        unit = {
            name: "",
            description: "",
            instructions: ""
        };
    },
    view: function () {
        return [
            m(".form-section required", [
                m(".form-label", i18n.t("name")),
                m("input[type=text]", {
                    onchange: function () {
                        UniqueName.checkUniqueUnitName("new", this.value)
                    },
                    oninput: function () {
                        unit.name = this.value;
                    }, value: unit.name
                })
            ]),
            m(".form-section", [
                m(".form-label", i18n.t("description_not_visible_to_learners")),
                m("textarea", {
                    oninput: function () {
                        unit.description = this.value;
                    }, value: unit.description
                })
            ]),
            m(".form-section", [
                m(".form-label", i18n.t("instructions_will_appear_for_learners")),
                m(TextEditor, {
                    content: encodeURIComponent(unit.instructions || ""),
                    hideHyperlink: true,
                    onchange: function (content) {
                        unit.instructions = content;
                    }
                })
            ]),
            m(".form-buttons", [
                saving
                ? m("button.btn-text no-click", [i18n.t("saving"), m(".loading-dots")])
                : !UniqueName.unitLoading && UniqueName.isUnitNameUnique
                    ? m("button", {onclick: saveUnit}, i18n.t("save"))
                    : m("button.btn-text no-click", i18n.t("save"))
            ])
        ];
    },
    setModalId: function(id) {
        modalId = id;
    }
};
export default Modal_Unit_Form_New;
